import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {TenantConfig} from '../../model/tenant-config';
import {AusschreibungService} from '../../service/ausschreibung.service';
import {PageTitleService} from '../../service/page-title.service';
import {TenantConfigService} from '../../service/tenant-config.service';
import {BreadcrumbNavComponent} from '../../shared/breadcrumb-nav/breadcrumb-nav.component';

@Component({
    imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, BreadcrumbNavComponent],
    selector: 'dah-lu-layout',
    templateUrl: './lu-app-layout.component.html',
    styleUrls: ['./lu-app-layout.component.css'],
    standalone: true
})
export class LuAppLayoutComponent {
  year = new Date().getFullYear();
  navOpen = false;
  accountOpen = false;
  signedIn = false;
  userName = '';
  tenant: TenantConfig = this.tenantConfigService.current;

  pageTitle: BehaviorSubject<string>;

  constructor(
    private ausschreibungService: AusschreibungService,
    private tenantConfigService: TenantConfigService,
    pageTitleService: PageTitleService,
  ) {
    this.pageTitle = pageTitleService.get();
    this.ausschreibungService.isSignedIn().subscribe(signedIn => this.signedIn = signedIn);
    this.ausschreibungService.displayName$.subscribe(user => this.userName = user);
  }
}
